import React from 'react'
import { H3, Text } from '@mxenabled/mxui'
import Box from '@mui/material/Box'
import { useCategoryStore, useGlobalCopyStore, useScreenSize } from '../../common'
import { DATE_FORMATS_INTL, formatDate } from '../../core/constants'

interface DateRangeTextProps {
  selectedDateRange: { start: Date; end: Date }
  selectedCategoryGuid: string
}

const DateRangeText = ({ selectedDateRange, selectedCategoryGuid }: DateRangeTextProps) => {
  const { trends: copy } = useGlobalCopyStore()
  const { isMobile, isDesktop } = useScreenSize()
  const { getCategoryName } = useCategoryStore()

  // Build date range text for display
  // e.g. October 2023 - March 2024, or Oct 2023 - Mar 2024
  const dateRangeText = React.useMemo(() => {
    const startDate =
      selectedDateRange.start.getFullYear() === selectedDateRange.end.getFullYear()
        ? formatDate(
            selectedDateRange.start,
            isMobile ? DATE_FORMATS_INTL.MONTH_SHORT : DATE_FORMATS_INTL.MONTH_LONG,
          )
        : formatDate(
            selectedDateRange.start,
            isMobile ? DATE_FORMATS_INTL.MONTH_SHORT_YEAR : DATE_FORMATS_INTL.MONTH_YEAR,
          )
    const endDate = formatDate(
      selectedDateRange.end,
      isMobile ? DATE_FORMATS_INTL.MONTH_SHORT_YEAR : DATE_FORMATS_INTL.MONTH_YEAR,
    )
    return `${startDate} - ${endDate}`
  }, [selectedDateRange, isMobile])

  const categoryName = getCategoryName(selectedCategoryGuid)
  const titleText = categoryName || (isMobile ? copy.sub_title : copy.sub_title_by_category)

  return (
    <Box>
      <H3
        sx={{
          fontSize: !isDesktop ? 15 : null,
          overflow: 'visible',
          textOverflow: 'unset',
        }}
      >
        {titleText}
      </H3>

      <Text variant={isDesktop ? 'subtitle1' : 'body2'}>{dateRangeText}</Text>
    </Box>
  )
}

export default DateRangeText
